import {CacheableDataObject} from "./CacheableDataObject";

class Locality extends CacheableDataObject
{

}

export {Locality};